import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  size?: 'lg' | 'xl';
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  size = 'lg',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center min-w-0 text-center font-oswald uppercase tracking-wider font-bold transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-gold-500 text-white hover:bg-gold-400 shadow-[0_5px_16px_rgba(234,88,12,0.28)] hover:shadow-[0_7px_20px_rgba(234,88,12,0.38)]',
    secondary: 'bg-navy-800 text-white border border-navy-700 hover:bg-navy-700 hover:border-gold-500/50'
  };
  const sizes = {
    lg: 'px-5 py-2.5 text-sm md:px-7 md:py-3 md:text-lg',
    xl: 'px-5 py-2.5 text-sm md:px-8 md:py-3.5 md:text-xl'
  };
  const width = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} rounded-lg ${className}`} {...props} data-id="element-259">
      <span className="relative z-10 flex w-full min-w-0 flex-col items-center justify-center break-words px-5 leading-tight" data-id="element-260">
        {children}
      </span>
      <ChevronRight aria-hidden="true" className="absolute right-3 z-10 h-4 w-4 flex-shrink-0 transition-transform group-hover:translate-x-1 md:right-4 md:h-4 md:w-4" data-id="element-261" />
      <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-262" />
    </motion.button>;
}